import React from "react";

interface IProps {
  child: React.ReactElement;
  visible: boolean;
}

const Visibility: React.FC<IProps> = ({
  child,
  visible,
}: IProps) => {

  return visible && child;
};

export { Visibility };
